import src from "./spices.jpg";
import src2x from "./spices@2x.jpg";
import src3x from "./spices@3x.jpg";
export default { src: src, srcSet: src + ", " + src2x + " 2x" + ", " + src3x + " 3x" };